export const strategyHero = {
  eyebrow: '国家战略',
  title: '国家战略正在推动融合',
  subtitle: '人工智能 · 数字乡村 · 县域商业 · 数据要素',
  desc: '国家战略正在推动人工智能、数字乡村、县域商业和数据要素加速融合，为乡村数字经济操作系统打开了一个全新的国家级产业窗口。',
};

export const policyTimeline = [
  {
    no: '政策 01',
    title: '乡村振兴',
    keywords: ['产业振兴', '消费振兴', '人才振兴', '组织振兴'],
    desc: '乡村振兴战略为县域与乡村产业发展提供顶层方向，推动农业农村现代化。',
  },
  {
    no: '政策 02',
    title: '数字乡村',
    keywords: ['数字农业', '农村电商', '农产品上行', '数字基础设施'],
    desc: '数字乡村建设以数字基础设施与数字农业为核心，加速农村电商与农产品上行。',
  },
  {
    no: '政策 03',
    title: '县域商业',
    keywords: ['县乡村商业体系', '供应链', '农村消费', '农产品流通'],
    desc: '县域商业体系建设完善县乡村三级商业网络，强化供应链与农产品流通。',
  },
  {
    no: '政策 04',
    title: '数据要素',
    keywords: ['数据资源', '数据流通', '数据价值', '数据安全'],
    desc: '数据要素市场化配置推动数据资源流通与价值释放，赋能产业数字化。',
  },
  {
    no: '政策 05',
    title: '人工智能应用服务商',
    tag: '工信厅科函〔2026〕414 号',
    keywords: ['人工智能+', '智能体', '小快轻准', '首购首用'],
    desc: '人工智能应用服务商政策方向，推动 AI 应用服务商入库、服务团组建与标准化产品包封装。',
    highlight: true,
  },
];

export const doc414 = {
  title: '从「数商共同体」到「人工智能应用服务商」',
  docName: '工信厅科函〔2026〕414 号',
  flow: [
    { icon: 'ri-file-text-line', label: '414 号文', desc: '人工智能应用服务商政策窗口' },
    { icon: 'ri-robot-2-line', label: '人工智能应用服务商', desc: '咨询规划 · 交付实施 · 运营管理 · 安全治理' },
    { icon: 'ri-store-2-line', label: '九畴云市', desc: '乡村数字经济 AI 应用服务链' },
  ],
  points: ['咨询规划', '交付实施', '运营管理', '安全治理'],
  combination: [
    'TOMA 智能体',
    '数字货架',
    '数币红包',
    '七方共利清分系统',
  ],
  target: '面向县域经济体、实体店及云社员等用户单位，解决农产品流通、数据价值和乡村消费数字化问题。',
};

export const formula = {
  base: [
    { title: '乡村振兴', icon: 'ri-flag-2-line' },
    { title: '数字乡村', icon: 'ri-signal-wifi-line' },
    { title: '县域商业', icon: 'ri-store-3-line' },
    { title: '数字经济', icon: 'ri-database-2-line' },
  ],
  core: {
    title: '人工智能应用服务商',
    doc: '工信厅科函〔2026〕414 号',
  },
  systems: [
    { title: 'AI 智能服务', icon: 'ri-robot-2-line' },
    { title: '县域数字商业', icon: 'ri-store-2-line' },
    { title: '农业产业流通', icon: 'ri-leaf-line' },
    { title: '数据要素与数字消费', icon: 'ri-red-packet-line' },
  ],
  result: {
    title: '九畴云市',
    sub: '乡村数字经济操作系统',
  },
};